(function () {
  const block = {
    $blocks: document.querySelectorAll('.tjh_gallery'),
    init() {
      if (this.$blocks.length) {
        this.$blocks
          .forEach(($block) => {
            PubSub.publish('embla.init', {
              name: 'media-gallery',
              $els: $block,
              options: {
                loop: true,
                dragFree: window.innerWidth > 768 && !$block.classList.contains('layout_normal')
              },
              plugins: [
                EmblaCarouselClassNames(),
                EmblaCarouselAutoScroll({
                  speed: 0.3,
                  playOnInit: false,
                  startDelay: 0
                })
              ]
            });
          });
      }
    }
  };

  block.init();
})();

